export default __webpack_public_path__ + "static/media/data_¿cuando-finaliza.8c6a024f.png";